// extracted by mini-css-extract-plugin
export var cardContainer = "_ny-0";
export var cardHeader = "_ny-2";
export var collapsedState = "_ny-3";
export var dragHandle = "_ny-5";
export var dragHandleIcon = "_ny-6";
export var dragging = "_ny-1";
export var titleArea = "_ny-4";